import {BonusBunniesHarvesterWinView} from "./BonusBunniesHarvesterWinView";
import {BaseController} from "@nolimitcity/slot-game/bin/core/base/BaseController";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {ScreenEvent} from "@nolimitcity/slot-game/bin/core/screen/event/ScreenEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {IBonusBunniesGameData} from "../../server/data/IBonusBunniesGameData";
import {BonusBunniesGameModuleConfig} from "../../BonusBunniesGameModuleConfig";

/**
 * Created by Jerker Nord on 2019-09-04.
 */

export class BonusBunniesHarvesterWinController extends BaseController {

    private _view:BonusBunniesHarvesterWinView;

    constructor() {
        super();
        this._view = BonusBunniesGameModuleConfig.bonusBunniesHarvesterWinView = new BonusBunniesHarvesterWinView();
    }
}